import { useEffect, useState } from 'react';
import {
  getOfflineSyncStatus,
  subscribeOfflineSyncStatus,
  type OfflineSyncStatus,
} from '@/lib/offline/offline-api';

/** État réseau + file de synchronisation de la progression (hors ligne). */
export function useOfflineSync(): OfflineSyncStatus {
  const [state, setState] = useState<OfflineSyncStatus>(() => getOfflineSyncStatus());
  useEffect(() => subscribeOfflineSyncStatus(setState), []);
  return state;
}
